import theme from '@styles/theme';
import { SVGProps } from 'react';

const CloudUploadIcon = ({
  width = 20,
  height = 21,
  fill,
  color = theme.palette.primary[0],
}: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    width={width}
    height={height}
    color={color}
    viewBox='0 0 20 21'
    fill={fill}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M12.5 12.6653L10 10.1653'
      stroke={'currentColor'}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10 10.1653L7.5 12.6653'
      stroke={'currentColor'}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M10.0002 16.832V10.1653'
      stroke={'currentColor'}
      strokeWidth='1.5'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M6.6665 16.7487C7.08072 16.7487 7.4165 16.4129 7.4165 15.9987C7.4165 15.5844 7.08072 15.2487 6.6665 15.2487V16.7487ZM1.6665 12.6653H0.916504H1.6665ZM4.99984 9.33199V10.082C5.21716 10.082 5.4238 9.98772 5.56625 9.82359C5.7087 9.65947 5.77296 9.44162 5.74238 9.22646L4.99984 9.33199ZM4.9915 9.27336L5.73404 9.16782L5.73397 9.16729L4.9915 9.27336ZM9.99984 3.49866L9.99984 2.74866H9.99983L9.99984 3.49866ZM15.0082 9.27336L14.2657 9.16729L14.2656 9.16782L15.0082 9.27336ZM14.9998 9.33199L14.2573 9.22645C14.2267 9.44162 14.291 9.65947 14.4334 9.82359C14.5759 9.98772 14.7825 10.082 14.9998 10.082V9.33199ZM13.3332 15.2487C12.919 15.2487 12.5832 15.5844 12.5832 15.9987C12.5832 16.4129 12.919 16.7487 13.3332 16.7487V15.2487ZM6.6665 15.2487H4.99984V16.7487H6.6665V15.2487ZM4.99984 15.2487C3.5731 15.2487 2.4165 14.0921 2.4165 12.6653H0.916504C0.916504 14.9205 2.74467 16.7487 4.99984 16.7487V15.2487ZM2.4165 12.6653C2.4165 11.2386 3.5731 10.082 4.99984 10.082V8.58199C2.74467 8.58199 0.916504 10.4102 0.916504 12.6653H2.4165ZM5.74238 9.22646L5.73404 9.16782L4.24897 9.37889L4.2573 9.43752L5.74238 9.22646ZM5.73397 9.16729C5.5573 7.93065 5.92597 6.6782 6.74445 5.73448L5.61126 4.75168C4.50788 6.0239 4.01088 7.71231 4.24904 9.37942L5.73397 9.16729ZM6.74445 5.73448C7.56292 4.79076 8.75064 4.24867 9.99984 4.24866L9.99983 2.74866C8.3158 2.74867 6.71464 3.47947 5.61126 4.75168L6.74445 5.73448ZM9.99983 4.24866C11.249 4.24867 12.4368 4.79076 13.2552 5.73448L14.3884 4.75168C13.285 3.47947 11.6839 2.74867 9.99984 2.74866L9.99983 4.24866ZM13.2552 5.73448C14.0737 6.6782 14.4424 7.93065 14.2657 9.16729L15.7506 9.37942C15.9888 7.71231 15.4918 6.0239 14.3884 4.75168L13.2552 5.73448ZM14.2656 9.16782L14.2573 9.22645L15.7424 9.43753L15.7507 9.37889L14.2656 9.16782ZM14.9998 10.082C16.4266 10.082 17.5832 11.2386 17.5832 12.6653H19.0832C19.0832 10.4102 17.255 8.58199 14.9998 8.58199V10.082ZM17.5832 12.6653C17.5832 14.0921 16.4266 15.2487 14.9998 15.2487V16.7487C17.255 16.7487 19.0832 14.9205 19.0832 12.6653H17.5832ZM14.9998 15.2487H13.3332V16.7487H14.9998V15.2487Z'
      fill={'currentColor'}
    />
  </svg>
);

export { CloudUploadIcon };
